// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nogUF","title":"Header_title__389iV","left":"Header_left__2Siwh","clinicName":"Header_clinicName__2whqX"};